var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFaceHappy = function SvgFaceHappy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M28.334 16c0 6.811-5.522 12.333-12.334 12.333C9.19 28.333 3.667 22.812 3.667 16 3.667 9.19 9.189 3.667 16 3.667c6.812 0 12.334 5.522 12.334 12.333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.468 16.172c2.53-2.007 2.9-3.932 2.151-5.107a2.032 2.032 0 0 0-1.634-.941c-.578-.022-1.165.206-1.624.707-.602-.314-1.232-.327-1.768-.109a2.032 2.032 0 0 0-1.213 1.444c-.303 1.36.703 3.042 3.768 4.063.11.037.23.015.32-.056ZM19.852 16.23c3.065-1.022 4.071-2.704 3.768-4.064a2.032 2.032 0 0 0-1.214-1.444c-.535-.218-1.165-.204-1.767.109-.459-.5-1.046-.729-1.624-.707a2.033 2.033 0 0 0-1.634.942c-.75 1.175-.38 3.099 2.15 5.107.091.072.212.093.321.056ZM15.998 24c2.696 0 4.924-2 5.283-4.596.054-.392-.291-.702-.685-.667a51.463 51.463 0 0 1-9.195 0c-.394-.035-.74.275-.685.667A5.334 5.334 0 0 0 15.999 24Z"
  })));
};
export default SvgFaceHappy;